import { useState, useEffect } from "react";

// Desktop breakpoint (US 14628): >= 800px renders the full desktop experience.
// Unlike the module-level `isDesktop` constant in utils.js (evaluated once at
// load), this hook reacts to live window resizing so desktop users keep the
// full UI when working in side-by-side / resized windows, not just on the
// initial page load.
export const DESKTOP_BREAKPOINT = 800;

const getIsDesktop = () => globalThis.innerWidth >= DESKTOP_BREAKPOINT;

const useIsDesktop = () => {
    const [isDesktop, setIsDesktop] = useState(getIsDesktop);

    useEffect(() => {
        const handleResize = () => setIsDesktop(getIsDesktop());

        window.addEventListener("resize", handleResize);
        // Sync once in case the width changed between initial render and effect.
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isDesktop;
};

export default useIsDesktop;
